import React from 'react';
import PropTypes from 'prop-types';

/**
 * Just the label of a single breadcrumb item.
 */
const BreadcrumbsLabel = ({ children }) => <span className="c-breadcrumbs__name">{children}</span>

export default BreadcrumbsLabel;

BreadcrumbsLabel.propTypes = {
  children: PropTypes.node.isRequired,
};
